/**
 * Роуты, открытые без авторизации.
 *
 * Роутер (`./index.tsx`) держит эти пути вне `RequireAuth`; здесь тот же список
 * нужен `AuthProvider`, который по нему решает, дёргать ли `/users/self` — на
 * публичной странице сессии нет, и запрос только шумит 401/редиректом на SSO.
 * Добавили публичный роут — обновите оба места.
 *
 * `/login` сюда НЕ входит: он тоже вне гарда, но профиль на нём запрашивать
 * нужно — по нему определяется, что юзер уже вошёл.
 *
 * ⚠️ Синхронизировано с `publicPaths` бэкенда `front` в конфиге gatekeeper
 * (Mongo `eai-gatekeeper.service-groups`). Добавили роут сюда — добавьте и там,
 * иначе шлюз редиректнёт на SSO до загрузки SPA.
 */
export const PUBLIC_ROUTES = [
  '/support',
  '/privacy-policy',
  '/cookie-policy',
] as const;

/**
 * Публичный ли путь.
 *
 * На вход — `window.location.pathname`, поэтому снимаем `BASE_URL`
 * (на стенде приложение может жить в подкаталоге) и хвостовые слэши.
 */
export const isPublicRoute = (pathname: string): boolean => {
  const base = import.meta.env.BASE_URL.replace(/\/$/, '');
  const withoutBase =
    base && pathname.startsWith(base) ? pathname.slice(base.length) : pathname;
  const normalized = withoutBase.replace(/\/+$/, '') || '/';
  return PUBLIC_ROUTES.some((route) => route === normalized);
};
